import { ROUTE_ROOT, ROUTE_APP } from "const";

export function getAbsLink(path: string) {
    return(ROUTE_ROOT + ROUTE_APP + "/" + path);
}